<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="user-tie"/>
          {{ $t('clientRegister') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :key="null" :title="$t('all')"></b-tab>
          <b-tab :key="1" :title="$t('notSuccess')"></b-tab>
          <b-tab :key="2" :title="$t('success')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <client-register-export :filter="filterFormModel" :total-count="itemCount"></client-register-export>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="col-12">
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg">{{$t('contact')}}</div>
            <div class="col-lg">{{$t('company')}}</div>
            <div class="col-lg">{{$t('status')}}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg">
              <div>
                <b>{{ $t('name') }}: </b>
                <span v-if="item.name">{{item.name}}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
                <span v-if="item.role" class="badge badge-primary ml-2">{{item.role}}</span>
              </div>
              <div><b>{{ $t('email') }}: </b><span>{{ item.email }}</span></div>
              <div><b>{{ $t('phone') }}: </b><span>{{ item.phone }}</span></div>
              <div v-if="item.utm_source"><b>utm_source: </b><span>{{ item.utm_source }}</span></div>
              <div v-if="item.utm_medium"><b>utm_medium: </b><span>{{ item.utm_medium }}</span></div>
              <div v-if="item.utm_campaign"><b>utm_campaign: </b><span>{{ item.utm_campaign }}</span></div>
            </div>
            <div class="col-lg">
              <div>
                <b>{{$t('businessCategory')}}: </b>
                <span v-if="item.category">{{item.category.map(c => `${c.code}. ${c.name}`).join(", ")}}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{$t('companySize')}}: </b>
                <span v-if="item.companySize">{{item.companySize}}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{$t('useNeed')}}: </b>
                <span v-if="item.useNeed && item.useNeed.length">{{item.useNeed.join(', ')}}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('sales') }}: </b>
                <span v-if="item.sales">{{ item.sales ? item.sales.name : "" }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('affiliate') }}: </b>
                <span v-if="item.affiliate">{{ item.affiliate ? `${item.affiliate.companyName} (${item.affiliate.domain})` : "" }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
            </div>
            <div class="col-lg">
              <div><b>{{ $t('updateTime') }}: </b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</div>
              <div>
                <b>Code: </b><span>{{item.code}}</span>&nbsp;&nbsp;|&nbsp;
                <b>Request: </b><span>{{item.request}}</span>
              </div>
              <div>
                <span v-if="item.isSuccess" class="badge badge-success">{{ $t('success') }}</span>
                <span v-else-if="item.confirmTime" class="badge badge-warning">{{$t('step', [3])}}</span>
                <span v-else-if="!item.confirmTime" class="badge badge-danger">{{$t('step', [2])}}</span>
              </div>
              <div>
                <span v-if="item.subscribe" class="badge badge-primary">Subscribe</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>

  </main>
</template>

<script>
import List from '@/mixins/List';
import TimeRangePicker from "@/components/TimeRangePicker";
import ClientRegisterExport from "./ClientRegisterExport";

export default {
  name: "ClientRegister",
  components: {
    ClientRegisterExport,
    TimeRangePicker
  },
  mixins: [List],
  data: function () {
    return {
      service: '/client-register',
      autoLoad: true,
      defaultFormModel: {
        keyword: null
      }
    }
  },
  methods: {
  },
  i18n: {
    messages: {
      en: {
        clientRegister: 'Client register',
        notSuccess: 'Not success',
        contact: "Contact",
        company: "Company",
        companySize: "Company size",
        useNeed: "Use need",
        role: "Role in company",
        step: "Step {0}",
        affiliate: "Affiliate"
      },
      vi: {
        clientRegister: 'Đăng ký dùng thử',
        notSuccess: 'Chưa thành công',
        contact: "Liên hệ",
        company: "Công ty",
        companySize: "Số lượng nhân viên",
        useNeed: "Nhu cầu",
        role: "Vị trí trong công ty",
        step: "Bước {0}",
        affiliate: "Giới thiệu"
      }
    }
  }
}
</script>